import axios from "axios";
import { API_URL } from "../../const";
export const fetchPerformanceReport = (fetchData: JSON) => {
  const data = {
    PerformanceReportToken: fetchData,
  };

  const url = `${API_URL}getPerformanceReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/** *************** END LIST OF PERFORMANCE REPORT  DETAILS ***************** */

/** *************** START EXPORT PERFORMANCE  REPORT  DETAILS ***************** */
export const ComonExportPage = (fetchData: JSON) => {
  const data = {
    CreateRequestReportToken: fetchData,
  };

  const url = `${API_URL}CreateRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** *************** END EXPORT PERFORMANCE  REPORT  DETAILS ***************** */
